'use strict';

angular.module('shiftTraderApp')
  .controller('ProfileAvailabilityCtrl', function ($scope, $filter, Session, ServerUrls, user,
                                                   positions, me, userAvailabilityChangeRequests, pending_in_review_availability_sets) {
    $scope.user = user;
    $scope.me = me;

    $scope.userAvailabilityChangeRequests = userAvailabilityChangeRequests;
    $scope.pending_in_review_availability_sets = pending_in_review_availability_sets;

    $scope.activeChangeRequest = _.find($scope.userAvailabilityChangeRequests, function(uacr) {
      return !uacr.$isExpired();
    });

    $scope.state = {
      hasChangeRequest: !_.isUndefined($scope.activeChangeRequest)
    };

    $scope.state.hasSetPendingForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasPendingAvailabilitySet();
    $scope.state.hasSetInReviewForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasInReviewAvailabilitySet();
    $scope.state.hasSetApprovedForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasApprovedAvailabilitySet();

    $scope.state.needToRespondToChangeRequest = !$scope.state.hasSetInReviewForChangeRequest && !$scope.state.hasSetApprovedForChangeRequest;
    $scope.state.hasSetInReviewAfterApproval = $scope.state.hasChangeRequest && $scope.state.hasSetApprovedForChangeRequest && $scope.state.hasSetInReviewForChangeRequest;
    $scope.state.hasSetPendingAfterApproval = $scope.state.hasChangeRequest && $scope.state.hasSetApprovedForChangeRequest && $scope.state.hasSetInReviewForChangeRequest;

    $scope.currentSet = _.find($scope.user.availability_sets, function(availSet) {
      return availSet.$isApproved() && availSet.$isInEffect() && availSet.active;
    });

    $scope.futureSet = _.find($scope.user.availability_sets, function(availSet) {
      return availSet.$isApproved() && !availSet.$isInEffect() && availSet.active;
    });

    $scope.inReviewSet = _.find($scope.pending_in_review_availability_sets, function(availSet) {
      return availSet.$isInReview() && availSet.active;
    });

    $scope.pendingSet = _.find($scope.pending_in_review_availability_sets, function(availSet) {
      return availSet.$isPending() && availSet.active;
    });

  });
